import React from 'react';
import { motion } from 'framer-motion';
import { Ship, Settings, LifeBuoy, ArrowRight, Wrench, ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-marine-navy overflow-hidden" data-id="element-228">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-wave-pattern opacity-50 pointer-events-none" data-id="element-229" />
      <div className="absolute top-0 right-0 -mr-32 -mt-32 w-80 h-80 rounded-full bg-marine-blue opacity-20 blur-3xl pointer-events-none" data-id="element-230" />
      <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-marine-cyan opacity-10 blur-3xl pointer-events-none" data-id="element-231" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-232">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-233">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-8 text-white" data-id="element-234">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 leading-tight" data-id="element-235">
              Marine, Industrial &{' '}
              <span className="text-marine-cyan" data-id="element-236">Fluid Transfer Pumps</span>
            </h1>

            <p className="text-base md:text-lg text-slate-300 mb-6 max-w-2xl leading-relaxed" data-id="element-237">
              CLR Marine carries pumps, pump parts, impellers, and repair kits
              for marine, RV, commercial, and industrial fluid transfer systems.
            </p>

            {/* Trust chips */}
            <div className="flex flex-wrap gap-2 mb-6" data-id="element-238">
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-3.5 py-1.5 text-xs sm:text-sm font-medium text-slate-200" data-id="element-239">
                <Ship className="w-4 h-4 text-marine-cyan" data-id="element-240" />
                Marine, RV & Industrial
              </div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-3.5 py-1.5 text-xs sm:text-sm font-medium text-slate-200" data-id="element-241">
                <Settings className="w-4 h-4 text-marine-cyan" data-id="element-242" />
                Parts, Impellers & Repair Kits
              </div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-3.5 py-1.5 text-xs sm:text-sm font-medium text-slate-200" data-id="element-243">
                <LifeBuoy className="w-4 h-4 text-marine-cyan" data-id="element-244" />
                Help Finding the Right Pump
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-245">
              <a href="https://www.clrmarine.com/531.html" className="inline-flex items-center justify-center gap-2 bg-marine-cyan hover:bg-cyan-400 text-marine-navy font-semibold px-5 py-3 rounded-lg transition-colors duration-200" data-id="element-246">
                Need help finding a pump?
                <ArrowRight className="w-4 h-4" data-id="element-247" />
              </a>
              <a href="https://www.clrmarine.com/544.html" className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-5 py-3 rounded-lg border border-white/20 transition-colors duration-200" data-id="element-248">
                <Wrench className="w-4 h-4" data-id="element-249" />
                Troubleshoot Your Pump
              </a>
            </div>
          </motion.div>

          {/* Decorative impeller */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="lg:col-span-4 hidden lg:flex justify-center relative" data-id="element-250">
            <div className="relative w-64 h-64" data-id="element-251">
              <div className="absolute inset-0 border-2 border-white/10 rounded-full" data-id="element-252" />
              <div className="absolute inset-3 border border-marine-cyan/30 rounded-full border-dashed" data-id="element-253" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-254">
                <div className="w-36 h-36 bg-marine-blue/40 rounded-full shadow-2xl shadow-marine-cyan/20 flex items-center justify-center border border-white/10" data-id="element-255">
                  <Settings className="w-16 h-16 text-marine-cyan" data-id="element-256" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Scroll cue to shopping section */}
        <div className="hidden md:flex items-center justify-center gap-2 mt-8 text-slate-400 text-xs uppercase tracking-widest" data-id="element-257">
          <span data-id="element-258">Shop pumps by manufacturer below</span>
          <ChevronDown className="w-4 h-4 animate-bounce" data-id="element-259" />
        </div>
      </div>
    </section>;
}